export const removeEmptyFicheLink = htmlString => {
	return htmlString.replace(
		/<a[^>]*?__product-fiche-link[^>]*?\*emptyFicheUrl\*.*?<\/a>/gs,
		'',
	);
};
